function avatarFor(nameOrId) {
  const initial = String(nameOrId || 'U').trim().slice(0, 1).toUpperCase() || 'U';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" rx="48" fill="#108a5f"/><text x="48" y="58" text-anchor="middle" font-family="Arial, sans-serif" font-size="38" font-weight="700" fill="#ffffff">${initial}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

function formatMessageTime(value) {
  if (!value) return '';
  const normalized = String(value).replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return '';
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

function formatAmountFromCents(value) {
  const amount = Number(value || 0);
  if (!amount) return '';
  return `¥${(amount / 100).toFixed(2)}`;
}

function conversationToContact(row = {}) {
  const peerName = row.peer_name || `用户 ${row.peer_id || ''}`.trim();
  const deal = row.support ? '客服支持' : (row.task_title || peerName);
  return {
    id: Number(row.id),
    conversationId: Number(row.id),
    peerId: Number(row.peer_id),
    name: peerName,
    avatar: row.peer_avatar || avatarFor(peerName || row.peer_id),
    lastMsg: row.last_body || '',
    time: formatMessageTime(row.last_message_at || row.created_at),
    unread: Number(row.unread || 0),
    deal,
    price: formatAmountFromCents(row.task_budget),
    isSupport: Boolean(row.support),
  };
}

function messageToBubble(row = {}, currentUserId) {
  return {
    id: Number(row.id),
    text: row.body || '',
    fromMe: Number(row.sender_id) === Number(currentUserId),
    time: formatMessageTime(row.created_at),
  };
}

function appendUniqueMessage(messages = [], nextMessage) {
  if (!nextMessage) return messages;
  if (messages.some(message => Number(message.id) === Number(nextMessage.id))) return messages;
  return [...messages, nextMessage];
}

function queryToPeerIntent(search = '') {
  const params = new URLSearchParams(search);
  const support = params.get('support');
  const peerId = Number(params.get('peerId'));
  const peerName = params.get('peerName')?.trim() || '';
  const taskId = Number(params.get('taskId'));

  if (support === '1' || support === 'true') {
    return { type: 'support' };
  }

  if (peerId) {
    return {
      type: 'real',
      peerId,
      peerName,
      taskId: taskId || null,
    };
  }

  if (peerName) {
    return {
      type: 'display-only',
      peerName,
    };
  }

  return { type: 'none' };
}

function buildMessageLink({ peerId, peerName, peerSeed, taskId } = {}) {
  const params = new URLSearchParams();
  if (peerName) params.set('peerName', peerName);
  if (peerSeed) params.set('peerSeed', peerSeed);
  if (Number(peerId)) params.set('peerId', String(Number(peerId)));
  if (Number(taskId)) params.set('taskId', String(Number(taskId)));
  const query = params.toString();
  return query ? `/messages?${query}` : '/messages';
}

export {
  appendUniqueMessage,
  buildMessageLink,
  conversationToContact,
  formatMessageTime,
  messageToBubble,
  queryToPeerIntent,
};
